import React from 'react'
import { If } from 'src/Components'
import { compose, withProps } from 'recompose'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import withComposedClassName from 'src/composables/withComposedClassName'
import omitProps from 'src/composables/omitProps'
import Button from 'src/Components/shared/Button'
import Badge from 'src/Components/shared/Badge'

import styles from './Navigation.module.scss'

const UnstyledLink = compose(
  withComposedClassName(({ active }) => active && styles.active),
  omitProps('active'),
  withProps({ element: Link })
)(Button)

const Root = withComposedClassName(styles.link)(UnstyledLink)

const NavLinkText = withComposedClassName(styles.linkText)('span')

export const NavLink = ({ children, newBadge, ...restProps }) => (
  <Root {...restProps}>
    <NavLinkText>{children}</NavLinkText>
    <If condition={newBadge}>
      <Badge.New />
    </If>
  </Root>
)

export const SubNavLink = withComposedClassName(styles.sublink)(UnstyledLink)

export const HomesLink = props => (
  <NavLink {...props}>
    <FormattedMessage
      id='Navigation.link.yourHomes.mobile'
      defaultMessage='Homes'
    />
  </NavLink>
)

export const MarketsLink = props => (
  <NavLink {...props}>
    <FormattedMessage
      id='Navigation.link.yourMarkets.mobile'
      defaultMessage='Markets'
    />
  </NavLink>
)

const BuyingReportLinkRoot = withComposedClassName(styles.buyingLink)(NavLink)

export const BuyingReportLink = props => (
  <BuyingReportLinkRoot {...props}>
    <FormattedMessage
      id='Navigation.link.buyingReport'
      defaultMessage='Buying Report'
    />
  </BuyingReportLinkRoot>
)
